import { supabase } from '@/lib/supabase';
import { serializeDate } from '@/shared/utils/date-utils';

export const updateProjectDates = async ({
  projectId,
  startDate,
  endDate,
}: {
  projectId: number;
  startDate?: Date | null;
  endDate?: Date | null;
}) => {
  const updateData: {
    start_date?: string | null;
    end_date?: string | null;
  } = {};

  // Only include fields that were actually provided
  if (startDate !== undefined) {
    updateData.start_date = startDate ? serializeDate(startDate) : null;
  }
  if (endDate !== undefined) {
    updateData.end_date = endDate ? serializeDate(endDate) : null;
  }

  const { error } = await supabase
    .from('projects')
    .update(updateData)
    .eq('id', projectId);
  if (error) throw error;
};
